import { useStyletron } from 'baseui';

const useAthenaDashboardHomeCss = () => {
	const [css] = useStyletron();

	const keyHeading = css({
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-evenly',
		alignItems: 'center',
		height: '100%'
	});

	const subKeyHeading = css({
		height: '130px',
		width: '40%',
		cursor: 'pointer'
	});

	const cardCSS = {
		width: '100%',
		height: '100%'
	};

	return { keyHeading, subKeyHeading, cardCSS };
};
export default useAthenaDashboardHomeCss;
